export default __webpack_public_path__ + "static/6-1658d49999ead3dce0868695cca9cb57.jpg";